import React, { useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import LineChartSkeleton from '../LineChartWidget/LineChartSkeleton';
import LineChartNoData from '../LineChartWidget/LineChartNoData';

import Styles from './styles.module.scss';
import '../../../../../yoello-lib/modules/components/Analytics/LineChartWidget/highcharts-tooltip.css';
import { useTranslation } from 'react-i18next';
import { PermissionsUI } from '../../Permissions/PermissionsUI';
import { ReactComponent as StatsIcon } from '../../../assets/images/total-breakdown-perm.svg';

export interface IColumnChartWidget {
    config: {}; //Highcharts configurations options. https://api.highcharts.com/highcharts/
    data?: any[];
    loading?: boolean;
    noDataText: string;
    title?: JSX.Element | string;
    seriesName?: string;
    seriesRounding?: number;
    separateVenueData: Array<any> | null;
    hasPermission?: boolean;
}

enum columnChartFilterOptions {
    CountOfOrders = 'count_of_orders',
    TotalRevenue = 'total_revenue',
    AvgSpend = 'avg_order_spend',
    TotalGratuity = 'total_gratuity',
    UniqueCustomers = 'total_unique_customers',
}

const ChartFilterOptionsList = [
    {
        title: 'Orders',
        valueKey: columnChartFilterOptions.CountOfOrders,
        translationKey: 'orders',
    },
    {
        title: 'Revenue',
        valueKey: columnChartFilterOptions.TotalRevenue,
        translationKey: 'revenue',
    },
    {
        title: 'Avg Spend',
        valueKey: columnChartFilterOptions.AvgSpend,
        translationKey: 'avgSpend',
    },
    {
        title: 'Tips',
        valueKey: columnChartFilterOptions.TotalGratuity,
        translationKey: 'tips',
    },
    // {
    //     title: "Unique Customers",
    //     valueKey: columnChartFilterOptions.UniqueCustomers,
    //     translationKey: "uniqueCustomers"
    // },
];

const ColumnChartWidget = (props: IColumnChartWidget) => {
    const [seletedChartFilterOption, setSeletedChartFilterOption] = useState<columnChartFilterOptions>(
        columnChartFilterOptions.CountOfOrders,
    );
    const { t } = useTranslation();
    const { hasPermission = true } = props;
    function getSeries() {
        return props.separateVenueData?.map((item) => {
            const itemValue = item.venueStatistic[seletedChartFilterOption]?.value;
            if (
                seletedChartFilterOption === columnChartFilterOptions.CountOfOrders ||
                seletedChartFilterOption === columnChartFilterOptions.UniqueCustomers
            ) {
                let value = null;
                if (itemValue) {
                    value = parseFloat(itemValue);
                }
                return [item.venue_name, value];
            } else {
                let value = null;
                if (itemValue) {
                    value = itemValue * 0.01;
                }
                return [item.venue_name, value];
            }
        });
    }
    function renderFilterOptions() {
        return ChartFilterOptionsList.map((item, i) => {
            return (
                <div
                    className={`${Styles.FilterOption} ${
                        seletedChartFilterOption === item.valueKey ? Styles.FilterOptionSelected : ''
                    }`}
                    key={item.translationKey + i}
                    onClick={() => setSeletedChartFilterOption(item.valueKey)}
                >
                    <p>{t(`analytics.columnChart.${item.translationKey}`)}</p>
                </div>
            );
        });
    }

    return (
        <div className={Styles.Widget}>
            {props.title}
            {!props.data || props.loading ? (
                <div>{props.loading ? <LineChartSkeleton /> : <LineChartNoData text={props.noDataText} />}</div>
            ) : (
                <div className={Styles.ChartWrapper}>
                    {hasPermission ? (
                        <>
                            <div className={Styles.FilterOptionsListDiv}>{renderFilterOptions()}</div>
                            <div>
                                <HighchartsReact
                                    containerProps={{
                                        style: {
                                            height: '100%',
                                            minWidth: `${(getSeries() || []).length * 34}px`,
                                        },
                                    }}
                                    highcharts={Highcharts}
                                    options={{
                                        ...props.config,
                                        series: [
                                            {
                                                name: ChartFilterOptionsList.filter(
                                                    (item) => item.valueKey === seletedChartFilterOption,
                                                )[0].title,
                                                data: getSeries(),
                                                dataLabels: {
                                                    enabled: true,
                                                    rotation: 0,
                                                    color: '#212121',
                                                    align: 'center',
                                                    format: '{point.y:.2f}', // two decimal
                                                    y: -5, // X pixels down from the top
                                                    style: {
                                                        fontSize: '12px',
                                                    },
                                                },
                                                states: {
                                                    hover: {
                                                        color: {
                                                            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                                                            stops: [
                                                                [0, '#815FE4'], // start
                                                                [0.5, '#C1CAE1'], // middle
                                                                [1, '#F3F4F9'], // end
                                                            ],
                                                        },
                                                    },
                                                },
                                                maxPointWidth: 30, // Width of the columns
                                                borderRadius: 8,
                                            },
                                        ],
                                    }}
                                />
                            </div>
                        </>
                    ) : (
                        <PermissionsUI icon={<StatsIcon />} />
                    )}
                </div>
            )}
        </div>
    );
};

export default ColumnChartWidget;
